import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pin",
  "use": "icon-pin-usage",
  "viewBox": "0 0 15 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 21\" id=\"icon-pin\"><g stroke=\"#fff\"><path d=\"M14.5 7.852c0 3.785-7 12.148-7 12.148s-7-8.363-7-12.148C.5 4.068 3.634 1 7.5 1s7 3.068 7 6.852Z\" /><circle cx=\"7.5\" cy=\"8\" r=\"2\" fill=\"#fff\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol